const adaMode = JSON.parse(localStorage.getItem('ada_mode'));
console.log(adaMode);        // true
console.log(typeof adaMode); // "boolean"

if (adaMode) {
  document.body.classList.add('ada-mode');
}

function toggleAdaMode() {
  const adaMode = JSON.parse(localStorage.getItem('ada_mode'));
  localStorage.setItem('ada_mode', JSON.stringify(!adaMode));
  document.body.classList.toggle('ada-mode');
}

document.querySelector('.ada-mode-toggle')?.addEventListener('click', toggleAdaMode);